import React, { useEffect, useState } from "react";
// import images
import logo from "../../assets/images/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatISO } from "date-fns";
import axios from "axios";
import { toast } from "react-toastify";
import LoaderModal from "../ModalLoader/LoaderModal";

const SignupComponent = () => {
  // for loading modal ==>
  const [showModal, setShowModal] = useState(false);

  // Get today's date in YYYY-MM-DD format
  const APi_Url = process.env.REACT_APP_ENIGMA_API;
  const naviagtion = useNavigate();
  const today = new Date();
  const createdDate = formatISO(today);


// Account create start


const AccountCreate = async (values) => {
  console.log("Form data Accout create", values);
  const data = {
    accountName: "Default",
    displayPriority: 1,
    createdDate: createdDate,
    userId:values,
    createdBy: values,
    deletedDate: createdDate,
    deletedBy: 0,
  };
    //  "#accountModal".modal("hide");
  // isDeleted: true,

  try {
    const response = await axios.post(
      `${APi_Url}api/account/create-default-source-account`,
      data,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
         
        },
      }
    );

    // console.log("RESPONSE CREATE ACCOUNT",response)
    if(response.status==200){
naviagtion("/login");
setShowModal(false);
    }
   
    
  } catch (error) {
    console.error("Error ", error);
    setShowModal(false);
  } 
};
useEffect(()=>{getAllDocuSign();},[])

const [websiteCreateAccount, setwebsiteCreateAccount] = useState();


const getAllDocuSign = async () => {
  setShowModal(true);
  try {
    const response = await axios.get(
      `${APi_Url}api/account/get-all-docusign`,

      {
        headers: {
          Accept: "application/json",
          // "Content-Type": "application/json",
          "Content-Type": "multipart/form-data",
         
        },
      }
    );
    if (response.status === 200) {
     
     
      setwebsiteCreateAccount(
        response?.data?.response[0].websiteCreateAccount
      );
     

      setShowModal(false);
    }
  } catch (error) {
    console.error("Error uploading image:", error);
    setShowModal(false);
  }
};



// Account create end










  const initialValues = {
    userEmail: "",
    password: "",
    userName: "",
    firstName: "",
    lastName: "",
    
  };

  const validationSchema = Yup.object({
    userEmail: Yup.string()
      .email("Invalid email format")
      .required("Email is Required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Email domain must be a valid domain"
      ),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is Required"),
      firstName: Yup.string()
      .min(1, "First Name must be at least 1 characters")
      .test(
        "no-spaces",
        "First Name must not contain only spaces or excessive spaces",
        (value) => {
          return value && !/^\s+$/.test(value) && !/\s\s+/.test(value);
        }
      )
      .required("First Name is Required"),
      lastName: Yup.string()
      .min(1, "Last Name must be at least 1 characters")
      .test(
        "no-spaces",
        "Last Name must not contain only spaces or excessive spaces",
        (value) => {
          return value && !/^\s+$/.test(value) && !/\s\s+/.test(value);
        }
      )
      .required("Last Name is Required"),
    
   
  });

  const onSubmit = async (values, { setSubmitting,resetForm }) => {
    setShowModal(true);
    const data = {
      ...values,
      emailAddress: values.userEmail,
      userName: values.firstName+values.lastName,
    };

    //
    try {
      const response = await axios.post(
        `${APi_Url}api/auth/NewRegister`,
        data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log("nwr register response",response);
      
      if(response.data.statusCode==200 && response.data.success==true){
        toast.success("Successfully Signup");
        AccountCreate(response.data.response.userId);
        resetForm();
        setShowModal(false);

        if(websiteCreateAccount){
          sendMailSignature(values);
        }
        else{
          adminUpdateEsignature(values);
        }
      }
      
      // toast.success("Successfully Signup");
      
      // Handle response data as needed
    } catch (error) {
      setShowModal(false);
      // console.error('Error config:', error.response.data.response);
      toast.error(error.response.data.response);
    } finally {
      setSubmitting(false); // Make sure to reset form state, if applicable
    }
    // simulate server response delay
    setTimeout(() => {
      setSubmitting(false);
    }, 1000);
  };
  const adminUpdateEsignature = async (values) => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/auth/update-mail-esignature-for-admin/${values.userEmail}`,

        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            
          },
        }
      );
      console.log("resposne profile send-mail-esignature-for-admin", response.data);
      if ( response.data.statusCode == 200 && response.data.success==true) {
        // console.log("resposne profile ", response.data.response);
        // setUserData(response?.data?.response);
        toast.success(response.data.response);
        setShowModal(false);
      }
      else{
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setShowModal(false);
    }
  };

  const sendMailSignature = async (values) => {
    try {
      const response = await axios.get(
        `${APi_Url}api/auth/send-mail-esignature/${values.userEmail}/${values.firstName}/${values.lastName}`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      console.log("send-mail-esignature response", response?.data);

      if (response?.data?.success == true) {
        toast.success("please check your email")
      }
    } catch (error) {
      console.error("Error ", error);
    }
  };


  return (
    <>
      <div className="sign_in_wrp">
        <div className="sign_in_wrp_cntnr">
          <div className="sign_in_innr">
            <div className="sign_in_innr_wrp">
              <div className="img_prt">
                <img src={logo} alt="logo_icon" />
                <h2> Welcome </h2>
                {/* <h2>Dashboard</h2> */}
              </div>
              <div className="cnct_prt">
                <div className="sign_in_cnct">
                  <div className="sgn_pg_lgo">
                    {/* <a href="#">
                  <img src={logo} alt="logo_icon"/>
                </a> */}
                  </div>
                  <div className="frm_wrp">
                    <h6>Signup to your Account</h6>
                    <Formik
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={onSubmit}
                    >
                      {({ isSubmitting, setFieldValue, values }) => (
                        <Form>
                          <div className="frm_fld">
                            <label>First Name</label>
                            <Field
                              type="text"
                              id="firstName"
                              name="firstName"
                              placeholder="firstName"
                              className="input"
                            />
                            <ErrorMessage
                              name="firstName"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                          <div className="frm_fld">
                            <label>Last Name</label>
                            <Field
                              type="text"
                              id="lastName"
                              name="lastName"
                              placeholder="lastName"
                              className="input"
                            />
                            <ErrorMessage
                              name="lastName"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                          
                         
                          <div className="frm_fld">
                            <label>Email</label>
                            <Field
                              type="email"
                              id="userEmail"
                              name="userEmail"
                              placeholder="userEmail"
                              className="input"
                            />
                            <ErrorMessage
                              name="userEmail"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                          <div className="frm_fld">
                            <label>password</label>
                            <Field
                              type="password"
                              id="password"
                              name="password"
                              placeholder="Password"
                              className="input"
                            />
                            <ErrorMessage
                              name="password"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                          <div className="frm_fld">
                            <input type="submit" value="Signup" />
                          </div>

                          <div className="frm_fld crt_btn_fld">
                            <Link
                              to={"/"}
                              className="crt_btn"
                              style={{ marginBottom: "35px" }}
                            >
                              Already have an account
                            </Link>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LoaderModal show={showModal} />
    </>
  );
};

export default SignupComponent;
